import axios from 'axios'
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../graphql/mutations'
import * as queries from '../../../graphql/queries';

export default {
  namespaced: true,
  state: {
    rightMoveLeadSummary: '',
    rightMoveFeeSummary: '',
    rightMoveSalesFee: {amount : 0, id : 0},
    rightMoveLettingsFee: {amount : 0, id : 0}
  },
  mutations: {
    SET_RIGHTMOVE_LEAD_SUMMARY(state, data) {
      state.rightMoveLeadSummary = data
    },
    SET_RIGHTMOVE_FEE_SUMMARY(state, data){
      state.rightMoveFeeSummary = data;
    },
    SET_RIGHTMOVE_SALES_FEE(state, data){
      state.rightMoveSalesFee = data;
    },
    SET_RIGHTMOVE_LETTINGS_FEE(state, data){
      state.rightMoveLettingsFee = data;
    }
  },
	actions :  {
        getRightmoveLeadSummary({commit, rootState}){
            return axios({
                method: 'GET',
                url: `${rootState.baseURL}/corporate/ownerapp/letmcletting/${rootState.user.ClientName}/rightmove/summary/leads`,
                headers: {
                  token: rootState.user.LoginToken,
                  api_key: rootState.apiKey
                },
                params: {
                    startDate: rootState.reportMonthStart.format("YYYY-MM-DD"),
                    endDate: rootState.reportMonthEnd.format("YYYY-MM-DD")
                }
            }).then(function(response){
                commit('SET_RIGHTMOVE_LEAD_SUMMARY', response.data)
            });
        },
        getRightmoveFeeSummary({commit, rootState}){
          return axios({
              method: 'GET',
              url: `${rootState.baseURL}/corporate/ownerapp/letmcletting/${rootState.user.ClientName}/rightmove/summary/fees`,
              headers: {
                token: rootState.user.LoginToken,
                api_key: rootState.apiKey
              },
              params: {
                startDate: rootState.reportMonthStart.format("YYYY-MM-DD"),
                endDate: rootState.reportMonthEnd.format("YYYY-MM-DD")
              }
          }).then(function(response){
              commit('SET_RIGHTMOVE_FEE_SUMMARY', response.data)
          });
      },
      getRightmoveSalesFee({commit, rootState}){
        console.log(rootState.reportMonthStart);
        API.graphql(
          graphqlOperation(queries.listRightmoveFees, {
          filter: { 
              startDate:
              {"eq" : rootState.reportMonthStart},
              endDate : {
                  "eq" : rootState.reportMonthEnd
              },
              feeType: {
                  "eq" : "sales"
              }
          }
        })).then(function(response){
          if (response.data.listRightmoveFees.items[0] === undefined){
              commit('SET_RIGHTMOVE_SALES_FEE', {amount : 0, id : 0})
          }
          else{
              commit('SET_RIGHTMOVE_SALES_FEE', response.data.listRightmoveFees.items[0]);
          }
        });
      },
      getRightmoveLettingsFee({commit, rootState}){
        console.log(rootState.reportMonthStart);
        API.graphql(
          graphqlOperation(queries.listRightmoveFees, {
          filter: { 
              startDate:
              {"eq" : rootState.reportMonthStart },
              endDate : {
                  "eq" : rootState.reportMonthEnd
              },
              feeType: {
                  "eq" : "lettings"
              }
          }
        })).then(function(response){
          if (response.data.listRightmoveFees.items[0] === undefined){
              commit('SET_RIGHTMOVE_LETTINGS_FEE', {amount : 0, id : 0})
          }
          else{
              commit('SET_RIGHTMOVE_LETTINGS_FEE', response.data.listRightmoveFees.items[0]);
          }
        });
      },
      updateRightmoveSalesFee({commit}, payload){
        API.graphql({ query: mutations.updateRightmoveFee, variables: {input: payload}}).then(function(response){
            commit('SET_RIGHTMOVE_SALES_FEE',  response.data.updateRightmoveFee);
        }).catch(e => {
          console.log(e);
        });
      },
      updateRightmoveLettingsFee({commit}, payload){
        API.graphql({ query: mutations.updateRightmoveFee, variables: {input: payload}}).then(function(response){
            commit('SET_RIGHTMOVE_LETTINGS_FEE',  response.data.updateRightmoveFee);
        }).catch(e => {
          console.log(e);
        });
      },
      createRightmoveLettingsFee({commit}, payload){
        API.graphql({query: mutations.createRightmoveFee, variables: { input: payload } }).then(response => {
             commit('SET_RIGHTMOVE_LETTINGS_FEE',  JSON.parse(JSON.stringify(response.data.createRightmoveFee)));
         }).catch(e => {
             console.log(e);
         });
     },
      createRightmoveSalesFee({commit}, payload){
         API.graphql({query: mutations.createRightmoveFee, variables: { input: payload } }).then(response => {
              commit('SET_RIGHTMOVE_SALES_FEE',  JSON.parse(JSON.stringify(response.data.createRightmoveFee)));
          }).catch(e => {
              console.log(e);
          });
      }
    },
}